import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    disciplinesRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid',
        borderColor: theme.palette.secondary.main,
        borderRadius: 5,
        marginBottom: 5,
        padding: 3
    }
}));

export {useStyles};
